module.exports = __webpack_public_path__ + "img/enj.d5e0d71e.svg";